export default {
  id: 'ID',
  name: 'Name',
  objects: 'Objects',
  type: 'Type',
  test: 'Test',
  entries: 'Number of entries',
  entriesDetail: 'Entries',
  delete: 'Delete list',
  deleteDetail: 'Delete',
  enterBothNameId: 'Please enter both Name and ID',
  empty: 'Empty list',
  duplicate: 'Duplicate',
  update: 'Update',
  listItems: 'List Items',
  updateItem: 'Update an element'
}
